import React from 'react';
import { Link } from 'react-router-dom';

const BATCHES = [
  {
    label: 'Batch 1',
    title: 'Summer Internship Program 2026 — Batch 1',
    description: 'June–July 2026 · Online · 1 Month',
    path: '/internship/summer-2026',
  },
  {
    label: 'Batch 2',
    title: 'Summer Internship Program 2026 — Batch 2',
    description: 'September 2026 · Online · 1 Month',
    path: '/internship/summer-2026-batch-2',
  },
];

function InternshipsPage() {
  return (
    <section className="internship-page" aria-labelledby="internships-heading">
      <div className="container internship-page-container">
        <Link className="internship-back-link" to="/#services">
          Back to Services
        </Link>
        <h1 id="internships-heading" className="internship-selection-heading">
          Internship Programs
        </h1>
        <p className="internship-selection-sub">
          Select a batch to view details about the program.
        </p>
        <div className="internship-batch-grid">
          {BATCHES.map((batch) => (
            <Link
              key={batch.path}
              to={batch.path}
              className="internship-batch-card"
              aria-label={`View details for ${batch.title}`}
            >
              <span className="internship-batch-label">{batch.label}</span>
              <h2 className="internship-batch-title">{batch.title}</h2>
              <p className="internship-batch-desc">{batch.description}</p>
              <span className="internship-batch-cta">View Details →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InternshipsPage;
